import { render, staticRenderFns } from "./NoteSimple.vue?vue&type=template&id=4b84eb7c&scoped=true"
import script from "./NoteSimple.vue?vue&type=script&lang=js"
export * from "./NoteSimple.vue?vue&type=script&lang=js"
import style0 from "./NoteSimple.vue?vue&type=style&index=0&id=4b84eb7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b84eb7c",
  null
  
)

export default component.exports